export function aboutFunc() {

  let aboutPage = $('#about').length;

  let subNav = document.getElementById('subNav');
  let brandMessage = $('#about.brandMessage').length;
  let subNavBtn = document.getElementById('subNavBtn');
  let subNavMenu = document.getElementById('subNavMenu');
    
  let aboutDistributorSubNavBtn = $('#aboutDistributorSubNavBtn');

  if (aboutPage) {

    if(!(brandMessage)){
      $(window).on('scroll', function () {
        let scrTop = $(window).scrollTop();
        if (scrTop > 20) {
          subNav.classList.add('notTop');
        } else {
          subNav.classList.remove('notTop');
        }
      });
    }

    //サブナビ
    if(!(brandMessage)){
      subNavBtn.addEventListener('click', function () {
        if (subNavMenu.classList.contains('isOpen')) {
          subNavBtn.classList.remove('isOpen');
          subNavMenu.classList.remove('isOpen');
        } else {
          subNavBtn.classList.add('isOpen');
          subNavMenu.classList.add('isOpen');
        }
      });
      $(window).on('scroll', function () {
        let scrTop = $(window).scrollTop();
        if (scrTop > 10) {
          subNavBtn.classList.remove('isOpen');
          subNavMenu.classList.remove('isOpen');
        }
      });
    }
     
    //地図サブナビ
    aboutDistributorSubNavBtn.on('click', function () {
        $(this).toggleClass('isOpen');
        $("html, body").animate({scrollTop: $('#aboutDistributorSubNav').offset().top - 140}, 1600, 'swing');
        return false;
    });
    
    //地図をクリックした際の処理
    var thisMap, continent, countryArea, changeJs, areaList, currentList, mapName, responsibleCheck, activeSp;
    thisMap = $('.globalMap').find('#global_map').find('g');
    countryArea = $('.aboutDistributorList');
    changeJs = $('.aboutDistributorSubNavMenu li');
            
    thisMap.hover(function () {
      continent = $(this).attr('id');
      $(this).find('path').addClass('cls-3'); 
      $(this).find('text').addClass('cls-4');
    }, function () {
      $(this).find('path').removeClass('cls-3'); 
      $(this).find('text').removeClass('cls-4');
    });
      
    thisMap.on('click', function () {
      areaList = $('section.' + continent);
      currentList = $('.aboutDistributorSubNavMenu li.' + continent);
      if ($(areaList).css('display') == 'none') {
        countryArea.not(areaList).css('display', 'none');
        areaList.css('display', 'block');
      };
        
      thisMap.removeClass('active');
      $(this).addClass('active'); 

      changeJs.removeClass('active');
      currentList.addClass('active');

      mapName = $(this).find('text').attr('id'); 
      $('.selectBtn').html(mapName);
      responsibleCheck = $('#responsibleCheck').width();
      activeSp = $('.activeSp');

      if (responsibleCheck == '2') {
        $('#changeJs').slideUp(500);
        activeSp.removeClass('isOpen');
      }
        
       let aboutDistributorBoxTop = $('.aboutDistributorBox').offset().top;
       $("html,body").animate({
            scrollTop:aboutDistributorBoxTop - 140
            }, 1200, 'swing');
            return false;
    });
 
    //地図サブナビをクリックした際の処理
      var thisArea, areaList,currentName;
      
      changeJs.on('click', function () {
        responsibleCheck = $('#responsibleCheck').width();
        thisArea = $(this).attr('class');
        areaList = $('section.' + thisArea);
        changeJs = $('#aboutDistributorSubNavMenu li');

        if ($(areaList).css('display') == 'none') {
          countryArea.not(areaList).css('display', 'none');
          areaList.css('display', 'block');
            
          $('g').removeClass('active');
          $('g#' + thisArea).addClass('active');
        }
          
          changeJs.removeClass('active');
          $(this).addClass('active');
          
          activeSp = $('.activeSp');
          if (responsibleCheck == '2') {
              $('#changeJs').slideUp(500);
              activeSp.removeClass('isOpen');
            }
          
          activeSp.removeClass('isOpen');
          
          currentName = $(this).html(); 
          $('.selectBtn').html(currentName);
          
          let aboutDistributorBoxTop = $('.aboutDistributorBox').offset().top;
            $("html,body").animate({
            scrollTop:aboutDistributorBoxTop - 140
            }, 1200, 'swing');
            return false;
      });
      
    //CEO interview
    let ceoInterviewNavLi = $('.ceoInterviewNavLi');
    let ceoInterviewPaging= $('.ceoInterviewPaging p a');
      
      ceoInterviewNavLi.on('click', function () {
          let article = $(this).index();
          
          $(".ceoInterviewArticleVol").removeClass("active");
          $(".ceoInterviewArticleVol").eq(article).addClass("active");

          ceoInterviewNavLi.removeClass('active');
          $(this).addClass('active');
          
          return false;
      });
      
      ceoInterviewPaging.on('click', function () {
          $(".ceoInterviewArticleVol").removeClass("active");
          $(".ceoInterviewArticleVol").filter(this.hash).addClass("active");

          ceoInterviewNavLi.removeClass('active');
          $('.'+$(this).attr('id')).addClass("active");
          
          $("html,body").animate({
            scrollTop:$(".ceoInterviewHeadTxt").offset().top
            }, 0, 'swing');
          
          return false;
      });

  }
}